var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99994 12.5366C8.70705 12.2437 8.70705 11.7689 8.99994 11.476L14.1317 6.34418C14.4246 6.05129 14.8995 6.05129 15.1924 6.34418C15.4853 6.63707 15.4853 7.11195 15.1924 7.40484L10.5909 12.0063L15.1924 16.6077C15.4853 16.9006 15.4853 17.3755 15.1924 17.6684C14.8995 17.9613 14.4246 17.9613 14.1317 17.6684L8.99994 12.5366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9b76b0e35623dfaa6516456a6431d2ad.svg";
export { ForwardRef as ReactComponent };